import { createAsyncAction } from "typesafe-actions";
import { AppNotificationDto } from "./notifications.dto";

export const notificationActions = createAsyncAction(
    'GET_NOTIFICATION_REQUEST',
    'GET_NOTIFICATION_SUCCESS',
    'GET_NOTIFICATION_ERROR',
  )<string, AppNotificationDto, string>();
  
  export const createNotificationActions = createAsyncAction(
    'CREATE_NOTIFICATION_REQUEST',
    'CREATE_NOTIFICATION_SUCCESS',
    'CREATE_NOTIFICATION_ERROR',
  )<AppNotificationDto, AppNotificationDto, string>();